import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import Login from "../pages/Login";
import Dashboard from "../pages/Dashboard";
import AddUser from "../pages/AddUser";
import Users from "../pages/Users";
import AddCase from "../pages/AddCase";
import Cases from "../pages/Cases";

import EditUser from "../pages/EditUser";
import CaseDetails from "../pages/CaseDetails";
import PrivateRoute from "../private/PrivateRoute";
import HistoryPage from "../pages/HistoryPage";
import EditCase from "../pages/EditCase";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <Login />,
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/dashboard",
        element: (
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        ),
      },
      {
        path: "/add-user",
        element: (
          <PrivateRoute>
            <AddUser />
          </PrivateRoute>
        ),
      },
      {
        path: "/users",
        element: (
          <PrivateRoute>
            <Users />
          </PrivateRoute>
        ),
      },
      {
        path: "/add-case",
        element: (
          <PrivateRoute>
            <AddCase />
          </PrivateRoute>
        ),
      },
      {
        path: "/cases",
        element: (
          <PrivateRoute>
            <Cases />
          </PrivateRoute>
        ),
      },
      {
        path: "/cases/edit/:id",
        element: (
          <PrivateRoute>
            <EditCase/>
          </PrivateRoute>
        ),
      },
      {
        path: "/users/edit/:id",
        element: (
          <PrivateRoute>
            <EditUser />
          </PrivateRoute>
        ),
      },
      {
        path: "/cases/:id",
        element: (
          <PrivateRoute>
            <CaseDetails />
          </PrivateRoute>
        ),
      },
      {
        path: "/case-history/:caseId",
        element: (
          <PrivateRoute>
            <HistoryPage />
          </PrivateRoute>
        ),
      },
    ],
  },
]);

export default router;
